var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DTabs',{attrs:{"items":[
            {"title":"Новости","const":"news"},
            {"title":"СМИ о нас","const":"smi"}
        ],"modelValue":_vm.newsSwitcher,"stretch":true,"color":"black"},model:{value:(_vm.newsSwitcher),callback:function ($$v) {_vm.newsSwitcher=$$v},expression:"newsSwitcher"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }